module.exports = __webpack_public_path__ + "static/fonts/BevIcons.2ae73cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/font/BevIcons.svg
// module id = 126
// module chunks = 0